module.exports = "<span class=\"base\">\r\n  <span [ngStyle]=\"{'font-size': increaseVal}\">{{untouched}}</span>\r\n  <span [ngStyle]=\"{'font-size': increaseVal}\">{{big}}</span>\r\n  <span [ngStyle]=\"{'font-size': decreaseVal}\">{{small}}</span>\r\n  <span [ngStyle]=\"{'font-size': increaseVal}\" *ngIf=\"mExists\">M</span>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/price-resize/price-resize.component.html
// module id = ../../../../../src/app/components/common/price-resize/price-resize.component.html
// module chunks = 0